import { useEffect, useState } from "react";
import { useContent } from "../context/ContentContext";

const resolveSrc = (v) => (v && v.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${v}` : v);

export const BG_SPEED_MS = { slow: 9000, medium: 6000, fast: 3500 };

export default function HeroBackdrop({ image, sectionKey, images, opacity = 0.38 }) {
  const { content } = useContent();
  let list = Array.isArray(images) ? images : null;
  if (!list && sectionKey) {
    const fromContent = content[`img.${sectionKey}.slides`];
    if (Array.isArray(fromContent) && fromContent.length) list = fromContent;
  }
  if (!list) list = image ? [image] : [];
  list = list.filter(Boolean);

  const speed = sectionKey ? content[`img.${sectionKey}.speed`] : null;
  const intervalMs = BG_SPEED_MS[speed] || BG_SPEED_MS.medium;

  const [i, setI] = useState(0);
  useEffect(() => {
    if (list.length <= 1) return;
    const reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const id = setInterval(() => setI((x) => (x + 1) % list.length), intervalMs);
    return () => clearInterval(id);
  }, [list.length, intervalMs]);

  if (list.length === 0) return <div className="absolute inset-0 bg-[#0F2744]" aria-hidden="true" />;
  const active = i % list.length;
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
      {list.map((src, idx) => (
        <img
          key={idx}
          src={resolveSrc(src)}
          alt=""
          loading={idx === 0 ? "eager" : "lazy"}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${idx === active && list.length > 1 ? "ken-burns-active" : ""}`}
          style={{ opacity: idx === active ? opacity : 0 }}
        />
      ))}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0F2744]/90 via-[#0F2744]/70 to-[#0F2744]/50" />
    </div>
  );
}
